import { render, staticRenderFns } from "./CommercialMovieSection.vue?vue&type=template&id=4c06e9e9&"
import script from "./CommercialMovieSection.vue?vue&type=script&lang=js&"
export * from "./CommercialMovieSection.vue?vue&type=script&lang=js&"
import style0 from "./CommercialMovieSection.vue?vue&type=style&index=0&id=4c06e9e9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports